import React from 'react'
import ModalContent from '../ModalContent'

export default function Login() {
  return <ModalContent initialState={'login'} />
}
